/**
 * Checks for valid JavaScript key
 *
 * This is not a full check, but it's enough for our use case
 */
export function isValidJSKey(key: string): boolean {
  return /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(key);
}
